module.exports = {
  "siteMetadata": {
    "title": "Weduc Academy",
    "description": "A weduc website",
    "author": "@accrosoft",
    "siteUrl": "https://weducacademy.co.uk",
    "defaultSiteImage": "https://cdn2.accropress.com/content-uploads%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F5wLTqxYGSiHpIC6D2xy8_content-uploads_temp-company-folder_temp-content-id-folder_00jlrfyrm2nxft8lenla_unnamed_png_png",
    "siteLogo": "https://cdn2.accropress.com/content-uploads%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F5wLTqxYGSiHpIC6D2xy8_content-uploads_temp-company-folder_temp-content-id-folder_00jlrfyrm2nxft8lenla_unnamed_png_png",
    "siteAvatar": "https://cdn2.accropress.com/content-uploads%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2FGDJSAuk7QWSShcgCiry4_content-uploads_temp-company-folder_temp-content-id-folder_00jlrfyrm2nxft8lenla_unnamed_png_png",
    "theme_color": null,
    "lang": "en"
  },
  "plugins": [{
    "resolve": "gatsby-plugin-accropress",
    "options": {
      "integrator": {
        "id": "9361bd0f-6313-4952-8dd1-e910ae0604b7",
        "accessToken": "a626dd77-a6ea-410d-8821-bf56f2f2d422",
        "redirectURL": "https://weducacademy.co.uk/"
      },
      "siteIDId": "6bb620f8-2183-4a7f-85d1-f34189c81132",
      "site": {
        "id": "6bb620f8-2183-4a7f-85d1-f34189c81132",
        "title": "Weduc Academy",
        "description": "A weduc website",
        "careersPageURL": "https://weducacademy.co.uk/vacancies",
        "careersPageVacancyURL": "https://weducacademy.co.uk/vacancies/vacancy",
        "siteUrl": "https://weducacademy.co.uk",
        "siteOwnerId": "4953d6eb-4231-4cc5-bfeb-f429d19efc1b",
        "siteTypeId": "b4ec3ca0-478b-46a4-b5e4-de24d86b787d",
        "deploymentsId": "6d66b889-54de-4df1-9e5d-9bb2cd61f4e2",
        "smartfeedSettingsId": null,
        "weducSettingsId": null,
        "useCustomContactForm": false,
        "isNovaSite": false,
        "novaSiteID": null,
        "novaCompanyIDs": [],
        "novaGroupIDs": [],
        "smartFeedID": null,
        "tenantUrl": "weduc-academy",
        "author": "@accrosoft",
        "defaultSiteImage": "https://cdn2.accropress.com/content-uploads%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F5wLTqxYGSiHpIC6D2xy8_content-uploads_temp-company-folder_temp-content-id-folder_00jlrfyrm2nxft8lenla_unnamed_png_png",
        "siteLogo": "https://cdn2.accropress.com/content-uploads%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F5wLTqxYGSiHpIC6D2xy8_content-uploads_temp-company-folder_temp-content-id-folder_00jlrfyrm2nxft8lenla_unnamed_png_png",
        "siteAvatar": "https://cdn2.accropress.com/content-uploads%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2FGDJSAuk7QWSShcgCiry4_content-uploads_temp-company-folder_temp-content-id-folder_00jlrfyrm2nxft8lenla_unnamed_png_png",
        "theme_color": null,
        "lang": "en",
        "tagManagerID": null,
        "googleAnalyticsID": null,
        "googleMapKey": null,
        "useGoogleJavascriptMaps": false,
        "useGoogleGeocodingMaps": false,
        "useGoogleEmbedMaps": false,
        "email_url": null,
        "twitter_url": null,
        "facebook_url": null,
        "nova_page_slug": null,
        "nova_page_id": null,
        "company_thumbnail": null,
        "company_hero": null,
        "company_video": null,
        "company_primary_colour": null,
        "company_primary_colour_hover": null,
        "company_secondary_colour": null,
        "company_secondary_colour_hover": null
      },
      "siteSettings": {
        "id": "ed48001f-bbeb-4f0c-b1b6-262770a1ea35",
        "themeSettingsPayload": [],
        "menusPayload": [],
        "widgetsPayload": [],
        "theme": {
          "id": "ecef0870-b44e-40b8-acf7-dace08ca6b4a",
          "name": "Alfred Weduc Websites Theme",
          "version": "1.0.0",
          "description": "Designed primarily for use with Primary Schools but can be used across all school types, features direct Weduc integration.",
          "tags": [],
          "previewThumbnail": "https://website-screens.accropress.com/be683bce-273c-4b7d-b1d5-1f2fc9b392e5.png",
          "previewDomain": "https://demo-alfred.weduc.website",
          "themeSettingsDefinition": [{
            "children": [{
              "id": "logo-image",
              "name": "Logo Image",
              "type": "image",
              "width": "100",
              "columns": "",
              "default": "https://demo-7.weduc.website/logo.png",
              "groupID": "basic-settings"
            }, {
              "id": "school-name-title",
              "name": "School Name Title",
              "type": "input",
              "width": "100",
              "columns": "",
              "default": "Weduc Academy",
              "groupID": "basic-settings"
            }, {
              "id": "school-name-subtitle",
              "name": "School Name Subtitle",
              "type": "input",
              "width": "100",
              "columns": "",
              "default": "Demo School",
              "groupID": "basic-settings"
            }, {
              "id": "theme-font-settings",
              "name": "Theme font settings",
              "type": "dropdown",
              "width": "100",
              "columns": "",
              "default": [{
                "name": "Poppins",
                "value": "Poppins",
                "fontFamily": "Poppins"
              }],
              "hiddenField": true
            }, {
              "id": "theme-colour-settings",
              "name": "Theme Colour Settings",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "theme-colour-settings-primary",
                "name": "Primary Colour",
                "type": "colour",
                "default": "#1fbdb7",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "theme-colour-settings-secondary",
                "name": "Secondary Colour",
                "type": "colour",
                "default": "#2d3e50",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "groupID": "colour-settings",
              "children": [[{
                "id": "theme-colour-settings-primary",
                "name": "Primary Colour",
                "type": "colour",
                "default": "#1fbdb7",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "theme-colour-settings-secondary",
                "name": "Secondary Colour",
                "type": "colour",
                "default": "#2d3e50",
                "maximum": 0,
                "minimum": 0
              }]]
            }, {
              "id": "home-banner-settings",
              "name": "Hero Banner Settings",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "home-banner-settings-image",
                "name": "Default Hero Image",
                "type": "input",
                "default": "https://cdn2.accropress.com/4953d6eb-4231-4cc5-bfeb-f429d19efc1b/c59afd92-2ba0-42f9-bdd2-69453ca150b4.jpeg",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "groupID": "hero-banner-settings",
              "children": [[{
                "id": "home-banner-settings-image",
                "name": "Default Hero Image",
                "type": "input",
                "default": "https://cdn2.accropress.com/4953d6eb-4231-4cc5-bfeb-f429d19efc1b/c59afd92-2ba0-42f9-bdd2-69453ca150b4.jpeg",
                "maximum": 0,
                "minimum": 0
              }]]
            }, {
              "id": "weduc-widgets-settings",
              "name": "Weduc Widgets Settings",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "weduc-widgets-settings-websitesid",
                "name": "Weduc Websites ID",
                "type": "input",
                "default": "weducdemositeuser",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-containerid",
                "name": "Weduc Main Container ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-entityid",
                "name": "Weduc Main Entity ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "groupID": "weduc-widgets-settings",
              "children": [[{
                "id": "weduc-widgets-settings-websitesid",
                "name": "Weduc Websites ID",
                "type": "input",
                "default": "weducdemositeuser",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-containerid",
                "name": "Weduc Main Container ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-entityid",
                "name": "Weduc Main Entity ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }]]
            }]
          }],
          "menusDefinition": [{
            "id": "primary-menu",
            "name": "Primary Menu",
            "children": [],
            "automatic-menu": true
          }],
          "widgetsDefinition": [{
            "children": [{
              "id": "footer-contact-details",
              "name": "Contact Details",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "footer-contact-details-ad1",
                "name": "Address Line One",
                "type": "input",
                "default": "Weduc Academy",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad2",
                "name": "Address Line Two",
                "type": "input",
                "default": "21 Jubilee Drive Loughborough",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad3",
                "name": "Address Line Three",
                "type": "input",
                "default": "LE11 5XS United Kingdom",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-tel",
                "name": "Telephone Number",
                "type": "input",
                "default": "+ 44 (0)1509 221 349",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-email",
                "name": "Email Address",
                "type": "input",
                "default": " info@weduc.co.uk",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-insta",
                "name": "Instagram Link",
                "type": "input",
                "default": null,
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-facebook",
                "name": "Facebook Link",
                "type": "input",
                "default": null,
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-twitter",
                "name": "Twitter Link",
                "type": "input",
                "default": null,
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "children": [[{
                "id": "footer-contact-details-ad1",
                "name": "Address Line One",
                "type": "input",
                "default": "Weduc Academy",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad2",
                "name": "Address Line Two",
                "type": "input",
                "default": "21 Jubilee Drive Loughborough",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad3",
                "name": "Address Line Three",
                "type": "input",
                "default": "LE11 5XS United Kingdom",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-tel",
                "name": "Telephone Number",
                "type": "input",
                "default": "+ 44 (0)1509 221 349",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-email",
                "name": "Email Address",
                "type": "input",
                "default": " info@weduc.co.uk",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-insta",
                "name": "Instagram Link",
                "type": "input",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-facebook",
                "name": "Facebook Link",
                "type": "input",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-twitter",
                "name": "Twitter Link",
                "type": "input",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }]]
            }, {
              "id": "footer-useful-links",
              "name": "Useful Links",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "footer-useful-links-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "children": [[{
                "id": "footer-useful-links-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }]],
              "repeater": true
            }, {
              "id": "footer-useful-resources",
              "name": "Useful Resources",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "footer-useful-resources-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "children": [[{
                "id": "footer-useful-resources-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }]],
              "repeater": true
            }, {
              "id": "footer-information",
              "name": "Information",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "footer-information-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "children": [[{
                "id": "footer-information-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }]],
              "repeater": true
            }],
            "widgetID": "footer"
          }],
          "templates": []
        }
      }
    }
  }, "gatsby-plugin-react-helmet", {
    "resolve": "gatsby-plugin-s3",
    "options": {
      "bucketName": "null-bucket.accropress.com",
      "mergeCachingParams": true,
      "generateRoutingRules": true,
      "generateRedirectObjectsForPermanentRedirects": false,
      "generateIndexPageForRedirect": true,
      "generateMatchPathRewrites": true,
      "removeNonexistentObjects": true,
      "enableS3StaticWebsiteHosting": false
    }
  }, "gatsby-plugin-sass", {
    "resolve": "gatsby-source-filesystem",
    "options": {
      "name": "images",
      "path": "./src/images"
    }
  }, {
    "resolve": "gatsby-plugin-google-tagmanager",
    "options": {
      "id": "GTM-KRXW5GQ",
      "includeInDevelopment": false,
      "defaultDataLayer": {
        "platform": "AccroPress"
      }
    }
  }, {
    "resolve": "gatsby-plugin-sentry",
    "options": {
      "dsn": "https://31544eb084ae44539700cd4d7e0ca55d@sentry.accropress.com/5",
      "environment": "production",
      "enabled": true
    }
  }, {
    "resolve": "gatsby-plugin-react-leaflet",
    "options": {
      "linkStyles": true
    }
  }, "gatsby-transformer-sharp", "gatsby-plugin-sharp", {
    "resolve": "gatsby-plugin-sitemap",
    "options": {
      "output": "/sitemap-pages.xml"
    }
  }, {
    "resolve": "gatsby-plugin-seo",
    "options": {
      "siteName": "Weduc Academy",
      "defaultSiteImage": "https://cdn2.accropress.com/content-uploads%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F5wLTqxYGSiHpIC6D2xy8_content-uploads_temp-company-folder_temp-content-id-folder_00jlrfyrm2nxft8lenla_unnamed_png_png",
      "siteUrl": "https://weducacademy.co.uk",
      "globalSchema": "{\n                  \"@type\": \"WebSite\",\n                  \"url\": https://weducacademy.co.uk,\n                  \"name\": Weduc Academy,\n                  \"image\": {\n                    \"@type\": \"ImageObject\",\n                    \"url\": https://cdn2.accropress.com/content-uploads%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F6bb620f8-2183-4a7f-85d1-f34189c81132%2F5wLTqxYGSiHpIC6D2xy8_content-uploads_temp-company-folder_temp-content-id-folder_00jlrfyrm2nxft8lenla_unnamed_png_png,\n                    \"caption\": Weduc Academy\n                  }\n                }"
    }
  }, {
    "resolve": "gatsby-plugin-manifest",
    "options": {
      "name": "Weduc Academy",
      "short_name": "Weduc Academy",
      "start_url": "/",
      "background_color": "#fff",
      "theme_color": "#000",
      "display": "standalone",
      "icon": "static/img/apple-icon.png"
    }
  }, {
    "resolve": "@accrosoft-ltd/gatsby-plugin-use-dark-mode",
    "options": {
      "classNameDark": "dark-mode",
      "classNameLight": "light-mode",
      "storageKey": "darkMode",
      "minify": true,
      "usePrefersColorScheme": false
    }
  }]
};